var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDmeCoin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2299 7.56141C15.5946 6.07589 13.5528 5.02691 11.2902 4.59945V6.18087L11.2909 6.18102V16.7167C10.7989 16.8565 10.2883 16.9524 9.76358 16.9998V4.09263L8.23625 2.31744V16.9998C7.71171 16.9524 7.20125 16.8565 6.70941 16.7168V4.98039L6.70883 4.98073V4.5996C4.44665 5.02712 2.40521 6.07593 0.770119 7.56115C1.35746 3.56697 4.81838 0.5 9.00002 0.5C13.1817 0.5 16.6427 3.5671 17.2299 7.56141Z",
    fill: "#FFDF37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 9.82742C16.0858 8.41285 14.5622 7.3031 12.8182 6.63658V16.1137C15.1908 14.8931 16.8967 12.5705 17.25 9.82742Z",
    fill: "#FFDF37"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.18209 16.1138V6.63639C3.43799 7.30285 1.91431 8.41259 0.75 9.82717C1.10328 12.5704 2.8093 14.8932 5.18209 16.1138Z",
    fill: "#FFDF37"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDmeCoin);
export default __webpack_public_path__ + "static/media/dme-coin.c60eb98a7b4b9b76af44cacf087481dc.svg";
export { ForwardRef as ReactComponent };